
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_REQUEST,
    MOVE_TO_OTHER_ACCOUNT_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { moveToOtherAccountGetDeviceResult, moveToOtherAccountResult } from 'Redux/actions';


function* getDevice({ payload }) {
    try {

        let { devices, accountId } = payload;
        const QUERY = `
        query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
            result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    companyId
                    id
                    label
                    esn
                    imei
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["esn", "imei", "label"],
                        terms: [devices],
                        exact: true
                    },
                    {
                        fields: ["companyId"],
                        terms: [accountId],
                        exact: true
                    }
                ],
                limit: 500,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(moveToOtherAccountGetDeviceResult(data?.result))
        } else {
            yield put(moveToOtherAccountGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(moveToOtherAccountGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/moveToOtherAccount/redux/saga",
            "getDevice",
        )
    }
}

function* moveToAnotherAccount({ payload }) {
    try {
        let { unitIds, newAccountId } = payload
        let QUERY = `
            mutation updateUnitsBatch ($unitIds: [Int]!, $features: UnitFeatureInput!, $simProviderAccountId: Int, $companyId: Int, $status: Int, $reference: String) {
                response: updateUnitsBatch (unitIds: $unitIds, features: $features, simProviderAccountId: $simProviderAccountId, companyId: $companyId, status: $status, reference: $reference){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate 
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                unitIds: unitIds,
                features: {},
                companyId: newAccountId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(moveToOtherAccountResult({ updateMoveAccount: data?.response }))

    } catch (exc) {
        if (exc?.error && exc?.error?.includes("ER_DUP_ENTRY")) {
            yield put(moveToOtherAccountResult({ updateMoveAccount: true }))
        } else {
            yield put(moveToOtherAccountResult({ updateMoveAccount: false }))
            ExceptionManager(
                exc,
                "Modules/devices/.components/moveToOtherAccount/redux/saga",
                "moveToAnotherAccount",
            )
        }
    }
}

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    status
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/devices/.components/moveToOtherAccount/redux/saga', 'getAccounts');
    }
}

function* watchMethods() {
    yield takeEvery(MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(MOVE_TO_OTHER_ACCOUNT_REQUEST, moveToAnotherAccount);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}